import React from 'react'
import ms1 from '../../images/mission/1.png'
import ms2 from '../../images/mission/2.png'
import ms3 from '../../images/mission/3.png'
import ms4 from '../../images/mission/4.png'
import './style.css'

const Mission = (props) => {
  return (
    <div className={`wpo-mission-area ${props.subclass}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <h2>What We Do</h2>
              <p className='wpo-section-para'><strong>Nirbaak</strong> celebrates the timeless art of <strong>Mime</strong>, using silent storytelling to inspire awareness, spark change, and touch hearts.</p>
            </div>
          </div>
        </div>
        <div className="wpo-mission-wrap">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12 col-12 custom-grid">
              <div className="wpo-mission-item">
                <div className="wpo-mission-icon-5">
                  <img src={ms1} alt="" />
                </div>
                <div className="wpo-mission-content">
                  <h2>Promote Mime Art
                  </h2>
                  <p>We are dedicated to reviving and popularizing the art of mime through workshops, performances, and collaborations across Assam and beyond.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12 custom-grid">
              <div className="wpo-mission-item">
                <div className="wpo-mission-icon-6">
                  <img src={ms2} alt="" />
                </div>
                <div className="wpo-mission-content">
                  <h2>Spread Social Awareness</h2>
                  <p>Our powerful mime acts address vital issues like health, environment, cyber safety, and child rights - bringing change through silent expression.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12 custom-grid">
              <div className="wpo-mission-item">
                <div className="wpo-mission-icon-7">
                  <img src={ms3} alt="" />
                </div>
                <div className="wpo-mission-content">
                  <h2>Cultural & Government Collaborations
                  </h2>
                  <p>We work closely with government departments and cultural bodies to deliver impactful street and stage performances for community outreach.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12 custom-grid">
              <div className="wpo-mission-item">
                <div className="wpo-mission-icon-8">
                  <img src={ms4} alt="" />
                </div>
                <div className="wpo-mission-content">
                  <h2>International Mime Journal</h2>
                  <p>Nirbaak, our annual journal, is a pioneering platform that documents, celebrates, and explores the world of mime at a global level.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Mission;